var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSettingsNotifications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "22px",
    viewBox: "0 0 19 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bell-ring") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-and-support---Done",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-main-page_-346",
    transform: "translate(-284, -586)",
    fill: "#DBE5FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(260.9765, 356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0, 164.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bell-ring",
    transform: "translate(23.0235, 65.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16194187,0 C5.1623491,0 1.92003853,3.24004457 1.92003853,7.23684211 L1.92003853,12.8815789 L0.317163926,15.2938596 C-0.0741513071,15.8967796 -0.1055751,16.6648849 0.235184715,17.2977127 C0.57594453,17.9305406 1.23472717,18.3275087 1.95383408,18.3333333 L16.3700497,18.3333333 C17.0939616,18.33094 17.7582277,17.9319417 18.0999924,17.2942254 C18.4417571,16.6565091 18.4059421,15.8828479 18.0067198,15.279386 L16.4038452,12.8815789 L16.4038452,7.23684211 C16.4038452,3.24004457 13.1615346,0 9.16194187,0 L9.16194187,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16666667,22 C10.5404131,21.9982263 11.7643074,21.0191109 12.2222222,19.5555556 L6.11111111,19.5555556 C6.56902598,21.0191109 7.79292026,21.9982263 9.16666667,22 Z",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSettingsNotifications);
export default __webpack_public_path__ + "static/media/ic_settings_notifications.a4d4261cec201b49bf44ea073190c595.svg";
export { ForwardRef as ReactComponent };